import React from "react";

import TablaVacaciones from "./TablaVacaciones";
import {
  comingSoonStyles,
  ComingSoonWrapper,
} from "src/components/coming-soon-screen/coming-soon-wrapper";
import { empleadosApi } from "src/services/empleadosApi";

export default function Vacaciones(props) {
  const {
    valueLaboral,
    empleado,
    setShowMessagePermiso,
    setColor,
    setMessage,
    vista,
  } = props;
  const { data } = empleadosApi.useGetVacacionesEmpleadoQuery(empleado.rut);
  const vacaciones = data?.vacaciones ?? [];
  const vacacionesSolicitadas = data?.vacacionesSolicitadas ?? 0;
  const vacacionesDisponibles = data?.vacacionesDisponibles ?? 0;

  return (
    <>
      {valueLaboral === 0 && (
        <ComingSoonWrapper style={comingSoonStyles.CARD}>
          <TablaVacaciones
            vacaciones={vacaciones}
            vacacionesSolicitadas={vacacionesSolicitadas}
            vacacionesDisponibles={vacacionesDisponibles}
            empleado={empleado}
            setShowMessagePermiso={setShowMessagePermiso}
            setColor={setColor}
            setMessage={setMessage}
            vista={vista}
          />
        </ComingSoonWrapper>
      )}
    </>
  );
}
